/**
 * Client-side environment configuration.
 * All values must be prefixed with `VITE_` to be exposed by Vite.
 * NEVER put server secrets here.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
  appName: (import.meta.env.VITE_APP_NAME as string) ?? 'DreamPick',
  appEnv: (import.meta.env.VITE_APP_ENV as string) ?? 'development',
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
} as const;

if (!env.apiBaseUrl) {
  // Fail fast in dev — surfaces missing config immediately.
  // eslint-disable-next-line no-console
  console.warn('[env] VITE_API_BASE_URL is not set. API calls will fail.');
}
